<template>
  <transition name="fade">
    <div class="singleWorkWrap" v-if="showSingleWork">
      <div class="singleWork">
        <div class="closeIcon" @click="changeShow">
          <img :src="closeIcon"/>
        </div>
        <div class="leftImg">
          <img :src="singleWork.src" alt="" :style="singleWork.style">
        </div>
        <div class="rightTxtWrap">
          <h4 v-html="singleWork.title"></h4>
          <div class="div" v-html="singleWork.enTitle"></div>
          <div class="p" v-html="singleWork.details"></div>
        </div>
      </div>
      
    </div>
  </transition>
</template>

<script>
import closeIcon from '@/assets/img/closeIcon.png'

export default {
  name: 'singleWork',
  
  data () {
    return {
      closeIcon, // 关闭按钮
    }
  },

  computed: {
    singleWork () {
      return this.$store.state.singleWork
    },
    showSingleWork () {
      return this.$store.state.showSingleWork
    }
  },

  methods: {
    changeShow () {
      this.$store.dispatch('changeSingleWork', false)
    },

  },

}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import './singleWork.styl'
</style>